import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const LazyForgeContentTools: LoadableType<{
	contentId: string;
	spaceKey: string;
	children: (items: React.JSX.Element[]) => React.ReactNode;
	onLoadComplete: () => void;
	isDropdownMenuOpen: boolean;
	lazyLoaderPlaceholderComponent?: React.ReactNode;
	onExtensionClose?: () => void;
}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ForgeContentTools" */ '../src/ForgeContentTools.tsx'
			)
		).ForgeContentTools,
});
